var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"addNewCashierdiary"}},[_c('div',{staticClass:"addNewCashierdiary_table"},[_c('cashierdiary-table',{ref:"cashierdiaryTableRef",attrs:{"isEdit":false,"c_title":"新增日记账","dataRow":_vm.dataRow}})],1),_vm._v(" "),_c('choice-type',{ref:"choiceTypeRef",on:{"saveSuccess":_vm.saveSuccess}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36b3f50e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/cashier/add-cashierdiary.vue
// module id = null
// module chunks = 